import { AnyAction, Dispatch } from 'redux'

import invitationService from './invitations-service'
import types from './types'

const fetchInviters = () => (dispatch: Dispatch<AnyAction>) => {
  dispatch({
    type: types.FETCH_INVITERS_START,
  })
  return invitationService
    .getInviters()
    .then((inviters) => {
      dispatch({
        type: types.FETCH_INVITERS_SUCCESS,
        payload: inviters,
      })
    })
    .catch(() => dispatch({ type: types.FETCH_INVITERS_FAILURE }))
}

const actions = {
  fetchInviters,
}

export default actions
